var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mainContentDiv',{staticClass:"pa-20"},[(_vm.tableOptions)?_c('tableList',{ref:"tableList",attrs:{"initOptions":_vm.tableOptions}}):_vm._e(),_c('centerDialog',{ref:"centerDialog"},[_c('inputCenter',{attrs:{"initOptions":_vm.initOptions_input}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }